import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Terms() {
  return (
    <div>
      {/* Header */}
      <Header showBack={true} />

      <div className="p-4">
        <div className="w-full max-w-md mx-auto flex flex-col gap-10">
          <Card>
            <CardHeader>
              <CardTitle className="text-2xl font-bold">
                Terms of Service
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-sm text-muted-foreground">
              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  1. Acceptance of Terms
                </h3>
                <p>
                  By accessing and using FellasCard services, you agree to be
                  bound by these Terms of Service and all applicable laws and
                  regulations. If you do not agree with any of these terms, you
                  are prohibited from using this service.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">2. Use of Service</h3>
                <p>
                  You may use our service for lawful purposes only. You agree
                  not to use the service in any way that violates any applicable
                  federal, state, local, or international law or regulation.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">3. User Account</h3>
                <p>
                  You are responsible for maintaining the confidentiality of
                  your account and password. You agree to accept responsibility
                  for all activities that occur under your account.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">4. Privacy</h3>
                <p>
                  Your use of our service is also governed by our Privacy
                  Policy. Please review our Privacy Policy, which also governs
                  the Site and informs users of our data collection practices.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  5. Intellectual Property
                </h3>
                <p>
                  The service and its original content, features, and
                  functionality are and will remain the exclusive property of
                  FellasCard and its licensors.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">6. Termination</h3>
                <p>
                  We may terminate or suspend your account immediately, without
                  prior notice or liability, for any reason whatsoever,
                  including without limitation if you breach the Terms.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">7. Disclaimer</h3>
                <p>
                  The information on this service is provided on an "as is"
                  basis. To the fullest extent permitted by law, FellasCard
                  excludes all representations and warranties relating to this
                  service and its contents.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  8. Limitation of Liability
                </h3>
                <p>
                  In no event shall FellasCard, nor its directors, employees,
                  partners, agents, suppliers, or affiliates, be liable for any
                  indirect, incidental, special, consequential, or punitive
                  damages.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">9. Changes to Terms</h3>
                <p>
                  We reserve the right, at our sole discretion, to modify or
                  replace these Terms at any time. If a revision is material, we
                  will try to provide at least 30 days notice prior to any new
                  terms taking effect.
                </p>
              </section>

              <section className="space-y-2">
                <h3 className="font-semibold text-base">
                  10. Contact Information
                </h3>
                <p>
                  If you have any questions about these Terms, please contact us
                  at legal@fellascard.com.
                </p>
              </section>

              <div className="pt-4 text-xs text-muted-foreground">
                Last updated: January 2025
              </div>
            </CardContent>
          </Card>

          {/* Footer */}
          <Footer />
        </div>
      </div>
    </div>
  );
}
